import ExaminationResultsLoading from './ExaminationResultsLoading';

export default ExaminationResultsLoading;
